// @flow
import type { TestSchedule, Product, CompanyBranch } from "../../lib/Types";

import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import React from "react";
import ProductsFilter from "./ProductsFilter";
import SchedulePicker from "./SchedulePicker";
import { fetchJson } from "../../lib/Fetching";

type Props = {
  company_id: number,
  registeringBranch: CompanyBranch,
  onBranchChange: (CompanyBranch) => void,
  fixedBranch: ?boolean,
  onlyPickSchedule: ?boolean,
  pickSchedule: ?Function,
  registerProtocol: ?Function,
  fixedBranch: ?boolean,
  authoriser: ?object,
};

type State = {
  products: Array<Product>,
  queryParams: object,
};

export default class ShoppingCart extends React.Component<Props, State> {
  state = {
    products: null,
  };

  static defaultProps = {
    onlyPickSchedule: false,
  };

  setProducts = (products: Array<Product>) => this.setState({ products });

  fetchProducts = () => {
    const { queryParams } = this.state;
    fetchJson("/products/products.json", queryParams).then(
      ({ products }: { products: Array<Product> }) =>
        this.setState({ products: products || [] })
    );
  };

  findProducts = (params) => {
    this.setState({ queryParams: params }, this.fetchProducts);
  };

  render() {
    const { products } = this.state;
    const {
      company_id,
      onBranchChange,
      registeringBranch,
      onlyPickSchedule,
      pickSchedule,
      registerProtocol,
      fixedBranch,
      authoriser,
    } = this.props;
    return (
      <div>
        <div style={{ maxWidth: 1900, margin: "0 auto" }}>
          <ProductsFilter
            key={registeringBranch.id}
            company_id={company_id}
            onBranchChange={onBranchChange}
            selectedCompanyBranchId={registeringBranch ? registeringBranch.id : null}
            fixedBranch={fixedBranch}
            findProducts={this.findProducts}
          />
        </div>
        {products !== null && (
          <SchedulePicker
            products={products}
            onlyPickSchedule={onlyPickSchedule}
            pickSchedule={pickSchedule}
            registerProtocol={registerProtocol}
            companyId={company_id}
            reloadProducts={this.fetchProducts}
            authoriser={authoriser}
          />
        )}
      </div>
    );
  }
}
